import React from 'react'; // , { useState, useEffect }
import { Navigate } from "react-router-dom";
import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterAction,
  CharacterSpell,
} from "@dndModels";

import API from "@dndUtilities/system_api";

import ViewSpell from "@dndComponents/display/ViewSpell";
import SpellDetails from "@dndComponents/display/SpellDetails";
import CharacterEffectsPDF from "@dndComponents/character/pdf/CharacterEffectsPDF";

interface Props { 
  char: Character;
  spells: CharacterSpell[];
  card_view: boolean;
  height: number;
}

const api = API.getInstance();

export default function CharacterSpellsPDF({
  char,
  spells,
  card_view,
  height,
}: Props) {

  const renderSpell = (char_spell: CharacterSpell) => {
    let action = char.actions.find(o => o.action instanceof CharacterSpell && o.action.true_id === char_spell.true_id);
    if (!action) {
      action = new CharacterAction();
      action.type = "Spell";
      action.special_action_type = "Spell";
      action.action = char_spell;
      action.level = char_spell.level;
      action.lowest = true;
      action.casting_time = char_spell.casting_time;
      action.special_casting_time = char_spell.the_spell?.special_casting_time??"";
    }
    if (card_view) {
      return (
        <Grid
          key={char_spell.true_id}
          className="padded"
          size={{
            xs: 4
          }}>
          <Grid container spacing={0} direction="row" style={{ border: "1px solid" }}>
            <Grid
              className="padded"
              size={{
                xs: 12
              }}>
              <ViewSpell spell={char_spell}
                // show_level 
                show_ritual
                fontSize={20}
                fontWeight={"bold"}
                character={char}
              />
            </Grid>
            <Grid
              className="padded"
              size={{
                xs: 12
              }}>
              <SpellDetails spell={char_spell} backgroundColor="white" />
            </Grid>
          </Grid>
        </Grid>
      );
    } else {
      return (
        <Grid
          key={char_spell.true_id}
          className="padded"
          size={{
            xs: 12
          }}>
          <Grid container spacing={0} direction="row" style={{ border: "1px solid" }}>
            <Grid
              className="padded"
              size={{
                xs: 6
              }}>
              <ViewSpell spell={char_spell}
                // show_level 
                show_ritual
                fontSize={20}
                fontWeight={"bold"}
                character={char}
              />
            </Grid>
            <Grid
              className="padded"
              size={{
                xs: 6
              }}>
              <Grid container spacing={0} direction="row">
                <Grid
                  className="centered"
                  size={{
                    xs: 3
                  }}>Cost</Grid>
                <Grid
                  size={{
                    xs: 9
                  }}>
                  <Grid container spacing={0} direction="row">
                    <Grid
                      className="centered"
                      size={{
                        xs: 5
                      }}>Range/Area</Grid>
                    <Grid
                      className="centered"
                      size={{
                        xs: 3
                      }}>Attack/DC</Grid>
                    <Grid
                      className="centered"
                      size={{
                        xs: 4
                      }}>Effect</Grid>
                  </Grid>
                </Grid>
                <Grid
                  size={{
                    xs: 12
                  }}>
                  <CharacterEffectsPDF 
                    character={char}
                    char_int={char}
                    obj={char_spell}
                    level={char_spell.level}
                    casting_time={char_spell.casting_time}
                    show_extra_effects={true} 
                    action={action}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              className="padded"
              size={{
                xs: 12
              }}>
              <SpellDetails spell={char_spell} backgroundColor="white" />
            </Grid>
          </Grid>
        </Grid>
      );
    }
  }

  if (api.user === null) {
    return <Navigate to="/labs" />;
  } else { 
    return (
      <div style={{ 
        fontWeight: "bold", 
        fontSize: "10px", 
        lineHeight: "1.5", 
        // border: "1px solid",
        margin: "10px" 
      }}>
        <Grid container spacing={0} direction="row">
          { spells.map(char_spell => renderSpell(char_spell))}
        </Grid>
      </div>
    ); 
  }
}
